import { ReactElement } from 'react'
import { VscHome, VscFolder, VscAccount, VscMegaphone, VscInfo, VscFileMedia, VscFile } from 'react-icons/vsc'

export type AppConfig = Array<{ icon: ReactElement, path: string, title: string, showInNav?: boolean }>

export const appConfig: AppConfig = [
  { icon: <VscHome />, path: '/', title: 'home' },
  { icon: <VscFolder />, path: '/projects', title: 'projects' },
  { icon: <VscFileMedia />, path: '/gallery', title: 'gallery' },
  { icon: <VscAccount />, path: '/aboutme', title: 'aboutme' },
  { icon: <VscMegaphone />, path: '/contact', title: 'contact' },
  { icon: <VscInfo />, path: '/impressum', title: 'impressum', showInNav: false },
  { icon: <VscFile />, path: '/readme', title: 'readme', showInNav: false }
]